import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const CheckList = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="Normal / List-Check" clipPath="url(#clip0_3001_4941)">
        <mask
          id="mask0_3001_4941"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <rect id="Bounding box" width="16" height="16" />
        </mask>
        <g mask="url(#mask0_3001_4941)">
          <g id="List-Check">
            <path d="M15 3H1C0.448 3 0 2.552 0 2C0 1.448 0.448 1 1 1H15C15.552 1 16 1.448 16 2C16 2.552 15.552 3 15 3ZM15 7H1C0.448 7 0 6.552 0 6C0 5.448 0.448 5 1 5H15C15.552 5 16 5.448 16 6C16 6.552 15.552 7 15 7ZM5.83333 11H1.16667C0.5215 11 0 10.553 0 10C0 9.447 0.5215 9 1.16667 9H5.83333C6.4785 9 7 9.447 7 10C7 10.553 6.4785 11 5.83333 11ZM5.83333 15H1.16667C0.5215 15 0 14.553 0 14C0 13.447 0.5215 13 1.16667 13H5.83333C6.4785 13 7 13.447 7 14C7 14.553 6.4785 15 5.83333 15Z" />
            <path d="M11 15C10.744 15 10.488 14.902 10.293 14.707L8.293 12.707C7.902 12.316 7.902 11.684 8.293 11.293C8.684 10.902 9.316 10.902 9.707 11.293L11 12.586L14.293 9.293C14.684 8.902 15.316 8.902 15.707 9.293C16.098 9.684 16.098 10.316 15.707 10.707L11.707 14.707C11.512 14.902 11.256 15 11 15Z" />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3001_4941">
          <rect width="16" height="16" />
        </clipPath>
      </defs>
    </svg>
  );
};

CheckList.displayName = 'CheckList';
